__turbopack_context__.v({
  "anchor": "Button-module-scss-module__HB5Z3q__anchor",
  "button": "Button-module-scss-module__HB5Z3q__button",
  "callToAction": "Button-module-scss-module__HB5Z3q__callToAction",
  "icon": "Button-module-scss-module__HB5Z3q__icon",
  "inset": "Button-module-scss-module__HB5Z3q__inset",
  "linkButton": "Button-module-scss-module__HB5Z3q__linkButton",
  "primary": "Button-module-scss-module__HB5Z3q__primary",
  "secondary": "Button-module-scss-module__HB5Z3q__secondary",
  "tertiary": "Button-module-scss-module__HB5Z3q__tertiary",
});
